import { useEffect, useState } from "react";
import { tokenStorage } from "../services/auth/tokenStorage";
import { UserApi } from "../services/api/user";
import { UserMeResponse } from "../types/types";

type UseCurrentUserOptions = {
  enabled?: boolean;
  onUnauthorized?: () => void;
};

export const useCurrentUser = (options: UseCurrentUserOptions = {}) => {
  const { enabled = true, onUnauthorized } = options;
  const [user, setUser] = useState<UserMeResponse | null>(null);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      setUser(null);
      setError(null);
      return;
    }

    const requestedToken = tokenStorage.getAccessToken();
    if (!requestedToken) {
      setLoading(false);
      setUser(null);
      setError(null);
      return;
    }

    let isMounted = true;

    setLoading(true);
    setError(null);

    UserApi.me()
      .then((response) => {
        if (!isMounted) {
          return;
        }

        setUser(response);
      })
      .catch((requestError) => {
        if (!isMounted) {
          return;
        }

        setError(requestError);
        setUser(null);

        const currentToken = tokenStorage.getAccessToken();
        if (currentToken === requestedToken) {
          onUnauthorized?.();
        }
      })
      .finally(() => {
        if (isMounted) {
          setLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [enabled, onUnauthorized]);

  return { user, setUser, loading, error };
};
